export const FormField = {
  flow: 'y',
  gap: 'Y',
  width: '100%',
  FieldLabel: { tag: 'label', text: (el, s) => s.label, fontSize: 'Y', fontWeight: '600', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: 'X' },
  FieldInput: { extends: 'Input', tag: 'input', type: (el, s) => s.type || 'text', placeholder: (el, s) => s.placeholder || '', value: (el, s) => s.value || '', padding: 'Z A', round: 'Y', background: 'inkSurface', color: 'inkText', border: '1px solid inkBorder', fontSize: 'Z', width: '100%' }
}
